import { RenderContext } from '@eventbrite/checkout-fairy-api';
import { formatDate } from '@eventbrite/datetime-fns';
import { EventStatus } from '../../../constants/eventStatus';

export const isDateDisabled =
    (eventDates: RenderContext['eventDates']) => (date: Date) =>
        !eventDates?.find((eventDate) => {
            if (eventDate.availability !== EventStatus.available) {
                return false;
            }

            return formatDate(date) == eventDate.date;
        });
